(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('oppOverMax', oppOverMax);

	function oppOverMax($rootScope, $scope, $location, $state, redirectParamsService, leanFilterService,
			tableRenderService, $timeout, tableService, storeService, flexColumns, columnsService) {

		var vm = this;
		vm.getData = getData;
		vm.getMeta = getMeta;
		var unsubscribe;

		vm.showExcel = true;

		var columnList = columns();
		var pinnedColumnList = [];

		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		vm.broadcastExcel = function() { $rootScope.$broadcast('export-excel', {columns: getExcelColumns(), doChooseColumns: true, exportFileName: reportSettingsId ? vm.reportName : undefined}); };

		var reportSettingsName = 'inventory-level-over-minmax-max';

		var rendererParams = {
			uomId: 'purchasingUOM',
			multiFactory: true,
			specificTaskType: 'task'
		};
		var extraParams = [{
			showExcel: true,
			excelReportName: 'Opportunity'
		},{
			name: 'reportRule',
			value: 'OnHandMoreMax'
		}];

		var defaultFilters = [
			{ id: 'factory', values: [globalConfig.factory.id], 'isMandatory': true },
			{ id: 'itemGroupNdx', values: [leanFilterService.leanDnaAllSelected] },
			{ id: 'supplierNdx', values: [leanFilterService.leanDnaAllSelected] },
			{ id: 'buyerCode', values: [leanFilterService.leanDnaAllSelected] }
		];

		leanFilterService.clearFilters();
		leanFilterService.useFactoryFilter = true;
		var siteFilter = leanFilterService.filterDefinitions['Factory'];
		siteFilter.type = 'multiselect';
		siteFilter.removable = false;
		var filters = {};
		filters.multiSelectFilters = [
			leanFilterService.filterDefinitions['BusinessUnit'],
			leanFilterService.filterDefinitions['Division'],
			leanFilterService.filterDefinitions['Entity'],
			siteFilter,
			leanFilterService.filterDefinitions['Item Group'],
			leanFilterService.filterDefinitions['Supplier'],
			leanFilterService.filterDefinitions['Buyer'],
			leanFilterService.filterDefinitions['Planner'],
			leanFilterService.filterDefinitions['MaterialGroup'],
			leanFilterService.filterDefinitions['MaterialType'],
			leanFilterService.filterDefinitions['TaskStatus'],
			leanFilterService.filterDefinitions['TaskCategory'],
			leanFilterService.filterDefinitions['Responsible']
		];
		filters = leanFilterService.addFlexFiltersBySourceType(['item'], filters);
		leanFilterService.setAllFilterLists(filters);

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.postData(params, extraParams, columns()).then(function (response) {
				return response;
			});
		}

		function getExcelColumns() {
			return columns().concat([{id: 'daysDisplayType'}]);
		}

		function columns() {
			var columns = [
				{
					id: 'actionStatus',
					display: 'Task Status',
					renderer: tableRenderService.statusWithCircle,
					pinnedLeft: true,
					sort: false,
					width: 80
				}, {
					id: 'itemCode',
					display: 'Item Code',
					renderer: tableRenderService.itemCode,
					pinnedLeft: true,
					width: 150
				}, {
					id: 'itemGroupName',
					display: 'Item Group',
					width: 150
				},
				{
					id: 'factoryName',
					display: 'Site'
				},
				{
					id: 'supplierName',
					display: 'Supplier'
				},
				{
					id: 'totalOnHandUnrestrictedQuantity',
					display: 'On Hand (Unrestricted)',
					renderer: tableRenderService.onHand
				},
				{
					id: 'totalOnHandConsignmentQuantity',
					display: 'Consignment Qty',
					show: false,
					renderer: tableRenderService.onHand
				},
				{
					id: 'minLevelFloat',
					display: 'Min Level',
					renderer: tableRenderService.integer
				},
				{
					id: 'maxLevelFloat',
					display: 'Max Level',
					renderer: tableRenderService.integer
				},
				{
					id: 'overMaxValue',
					display: 'Value Over Max',
					sortDefaultReverse: true,
					renderer: tableRenderService.currency
				},
				{
					id: 'calculatedMinLevel',
					display: 'Recommended Min Level',
					renderer: tableRenderService.integer
				},
				{
					id: 'calculatedMaxLevel',
					display: 'Recommended Max Level',
					renderer: tableRenderService.integer
				},
				{
					id: 'analysisTargetInventoryQty',
					display: 'Target Qty',
					class: 'alignRight',
					show: false,
					renderer: tableRenderService.targetQtyRenderer
				},
				{
					id: 'estimatedSavings',
					display: 'Estimated Savings',
					show: false,
					renderer: tableRenderService.currency
				},
				{
					id: 'weeklyInventoryDelta',
					display: 'Weekly Inventory Change',
					class: 'alignRight',
					renderer: tableRenderService.ppvRenderer
				},
				{
					id: 'weeklyOpportunityDelta',
					display: 'Weekly Opportunity Change',
					class: 'alignRight',
					renderer: tableRenderService.ppvRenderer,
					show: false
				},
				{
					id: 'next30Days',
					display: 'On Order Next 30 Days',
					class: 'alignRight',
					renderer: tableRenderService.onOrderNextXDays,
					show: false,
					days: 30
				},
				{
					id: 'next60Days',
					display: 'On Order Next 60 Days',
					class: 'alignRight',
					renderer: tableRenderService.onOrderNextXDays,
					show: false,
					days: 60
				},
				{
					id: 'next90Days',
					display: 'On Order Next 90 Days',
					class: 'alignRight',
					renderer: tableRenderService.onOrderNextXDays,
					show: false,
					days: 90
				},
				{
					id: 'totalOnOrderQuantityFloat',
					display: 'On Order Qty',
					width: 80,
					show: false,
					renderer: tableRenderService.hyperlinkShortage
				},
				{
					id: 'totalOnOrderValue',
					display: 'Total On Order Value',
					width: 80,
					show: false,
					renderer: tableRenderService.onOrderValue
				},
				{
					id: 'costPerItemFloat',
					display: 'Unit Price',
					renderer: tableRenderService.currency,
					'keepAllDecimals': true
				},
				{
					id: 'purchasingUOM',
					display: 'UOM',
					show: false
				},
				{
					id: 'abcClass',
					display: 'ABC Rank'
				},
				{
					id: 'totalOnHandQuantityFloat',
					display: 'Total On Hand Qty',
					renderer: tableRenderService.integer,
					show: false
				},
				{
					id: 'currentOnHandCostFloat',
					display: 'Total On Hand Value',
					renderer: tableRenderService.currency,
					show: false
				},
				{
					id: 'leadTimeInDaysFloat',
					display: 'Lead Time',
					class: 'alignRight',
					renderer: tableRenderService.leadTime,
					show: false
				}];
			columns = columns.concat(columnsService({
				analysisAvgDailyDemandFloat: 1,
				averageDailyDemandFromPastRqmts: 0,
				averageDailyDemandFromFutureRqmts: 0,
				isVmi: 0
			}));
			columns = columns.concat([
				{
					id: 'buyerCode',
					display: 'Buyer'
				},
				{
					id: 'planner',
					display: 'Planner',
					width: 100,
					show: false
				},
				{
					id: 'analysisReplenishmentType',
					display: 'Recommended Policy',
					show: false
				},
				{
					id: 'productHierarchy',
					display: 'Product Hierarchy',
					show: false
				},
				{
					id: 'externalMaterialGroup',
					display: 'External Material Group',
					show: false
				}, {
					id: 'materialType',
					display: 'Material Type',
					show: false,
					width: 80
				}, {
					id: 'materialGroup',
					display: 'Material Group',
					show: false,
					width: 80
				}
			]);
			columns = flexColumns.addFlexColumnsBySourceType(['item'], columns);
			return columns;
		}

		var meta = {
			reportName: 'Inventory level over MinMax max',
			reportSettingsName: reportSettingsName,
			reportSettingsId: reportSettingsId,
			noPaging: false,
			pageSize: 50,
			defaultSort: 'overMaxValue',
			defaultSortDirection: 'desc',
			defaultFilters: defaultFilters,
			rendererParams: rendererParams,
			extraParams: extraParams,
			columns: columnList,
			reportUrl: '{0}/ItemReport/Opportunities/OnHandMoreMax' ,
			pinnedColumns: pinnedColumnList,
			hideSearch: false,
			footer: false,
			setColumnDefaults: true,
			excelRequest: true,
			useReportBuilderForExcel: true,
			excelReportName: 'Opportunity',
			hasMandatoryFilters: true
		};
		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = meta.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = meta.reportName;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});
	}
})();
